import styled from "styled-components";

export const AccountNavComponentContainer = styled.nav`
    button {
        width: 100%;
    }

    @media screen and (max-width: ${props => props.theme.mobile}) {
        a button {
            margin-bottom: 10px;
        }

        a:last-child button {
            margin-bottom: 0;
        }
    }
`



// WEBPACK FOOTER //
// ./src/components/pages/account/AccountNavComponentStyle.js